module.exports = __webpack_public_path__ + "static/media/80.c0974a9.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/80.wav
// module id = UgZ0
// module chunks = 0